import React from "react";

const LastPageIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.19427 5.40667L6.7876 8L4.19427 10.5933C3.93427 10.8533 3.93427 11.2733 4.19427 11.5333C4.45427 11.7933 4.87427 11.7933 5.13427 11.5333L8.19427 8.47333C8.45427 8.21333 8.45427 7.79333 8.19427 7.53333L5.13427 4.46667C4.87427 4.20667 4.45427 4.20667 4.19427 4.46667C3.94093 4.72667 3.94093 5.15333 4.19427 5.40667ZM11.3343 4C11.7009 4 12.0009 4.3 12.0009 4.66667V11.3333C12.0009 11.7 11.7009 12 11.3343 12C10.9676 12 10.6676 11.7 10.6676 11.3333V4.66667C10.6676 4.3 10.9676 4 11.3343 4Z" fill="#4F4A4A"/>
  </svg>
);

export default LastPageIcon;
